.inspirations {
  max-width: 1600px;
  background-color: var(--color-white);
  margin: 0 auto;

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 20px;
    grid-column-gap: 20px;

    @include breakpointMax('sm') {
      &.columns-4 {
        grid-template-columns: 1fr;
      }
    }

    @include breakpointMin('lg') {
      &.columns-4 {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
    }
  }
}


